function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1992(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 21.27,
    height: 12.6,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.84
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.635,
    y: 6.3,
    fontFamily: "Arial"
  }, "\n        Highland_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 12.6,
    width: 21.27,
    height: 13.94,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.2672727272727273
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.635,
    y: 19.57,
    fontFamily: "Arial"
  }, "\n        Norton_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 26.54,
    width: 21.27,
    height: 15.49,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.8605555555555555
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.635,
    y: 34.285,
    fontFamily: "Arial"
  }, "\n        Manassas_Park_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 42.03,
    width: 21.27,
    height: 16.86,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.9366666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.635,
    y: 50.46,
    fontFamily: "Arial"
  }, "\n        Clifton_Forge_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 58.89,
    width: 21.27,
    height: 19.81,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.238125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.635,
    y: 68.795,
    fontFamily: "Arial"
  }, "\n        Buena_Vista_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 78.7,
    width: 21.27,
    height: 20.5,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.4642857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.635,
    y: 88.95,
    fontFamily: "Arial"
  }, "\n        Lexington_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 99.19,
    width: 21.27,
    height: 20.68,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.7233333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.635,
    y: 109.53,
    fontFamily: "Arial"
  }, "\n        Craig_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 119.87,
    width: 21.27,
    height: 20.88,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.74
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.635,
    y: 130.31,
    fontFamily: "Arial"
  }, "\n        Emporia_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 140.75,
    width: 21.27,
    height: 20.98,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.9072727272727272
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.635,
    y: 151.24,
    fontFamily: "Arial"
  }, "\n        Bath_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 161.73,
    width: 21.27,
    height: 21.1,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.1100000000000003
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.635,
    y: 172.28,
    fontFamily: "Arial"
  }, "\n        Galax_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 182.83,
    width: 21.27,
    height: 21.69,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.7725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.635,
    y: 193.675,
    fontFamily: "Arial"
  }, "\n        Bedford_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 204.52,
    width: 21.27,
    height: 24.82,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.2511764705882353
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.635,
    y: 216.93,
    fontFamily: "Arial"
  }, "\n        South_Boston_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 229.34,
    width: 21.27,
    height: 25.5,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.7725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.635,
    y: 242.09,
    fontFamily: "Arial"
  }, "\n        Bland_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 254.84,
    width: 21.27,
    height: 25.83,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.5192857142857144
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.635,
    y: 267.755,
    fontFamily: "Arial"
  }, "\n        Covington_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 280.67,
    width: 21.27,
    height: 26.26,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.012857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.635,
    y: 293.8,
    fontFamily: "Arial"
  }, "\n        King_and_Queen_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 306.93,
    width: 21.27,
    height: 27.13,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.1194736842105264
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.635,
    y: 320.495,
    fontFamily: "Arial"
  }, "\n        Charles_City_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 334.06,
    width: 21.27,
    height: 27.46,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.418
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.635,
    y: 347.79,
    fontFamily: "Arial"
  }, "\n        Richmond_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 361.52,
    width: 21.27,
    height: 28.64,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.1194736842105264
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.635,
    y: 375.84,
    fontFamily: "Arial"
  }, "\n        Rappahannock_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 390.16,
    width: 21.27,
    height: 29.48,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.7725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.635,
    y: 404.90000000000003,
    fontFamily: "Arial"
  }, "\n        Surry_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 419.65,
    width: 21.27,
    height: 30.06,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.636153846153846
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.635,
    y: 434.67999999999995,
    fontFamily: "Arial"
  }, "\n        Franklin_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 449.71,
    width: 21.27,
    height: 30.47,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.2511764705882353
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.635,
    y: 464.945,
    fontFamily: "Arial"
  }, "\n        Cumberland_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 480.17,
    width: 21.27,
    height: 33.48,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.2511764705882353
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.635,
    y: 496.91,
    fontFamily: "Arial"
  }, "\n        Williamsburg_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 513.66,
    width: 21.27,
    height: 35.15,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.7725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.635,
    y: 531.235,
    fontFamily: "Arial"
  }, "\n        Essex_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 548.8,
    width: 21.27,
    height: 35.89,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.1816666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.635,
    y: 566.745,
    fontFamily: "Arial"
  }, "\n        Greensville_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 584.69,
    width: 21.27,
    height: 38.03,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.636153846153846
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.635,
    y: 603.705,
    fontFamily: "Arial"
  }, "\n        Amelia_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 622.72,
    width: 21.27,
    height: 38.29,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.636153846153846
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.635,
    y: 641.865,
    fontFamily: "Arial"
  }, "\n        Sussex_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 661.01,
    width: 21.27,
    height: 38.99,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.636153846153846
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.635,
    y: 680.505,
    fontFamily: "Arial"
  }, "\n        Greene_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.27,
    y: 0,
    width: 27.98,
    height: 30.97,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.9985714285714287
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 35.26,
    y: 15.485,
    fontFamily: "Arial"
  }, "\n        Mathews_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.25,
    y: 0,
    width: 28.74,
    height: 30.97,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.210769230769231
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 63.62,
    y: 15.485,
    fontFamily: "Arial"
  }, "\n        Clarke_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.98,
    y: 0,
    width: 28.97,
    height: 30.97,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.810625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 92.465,
    y: 15.485,
    fontFamily: "Arial"
  }, "\n        Middlesex_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 106.95,
    y: 0,
    width: 29.55,
    height: 30.97,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.1107142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 121.72500000000001,
    y: 15.485,
    fontFamily: "Arial"
  }, "\n        Madison_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 136.5,
    y: 0,
    width: 29.58,
    height: 30.97,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.465
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 151.29,
    y: 15.485,
    fontFamily: "Arial"
  }, "\n        Radford_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 166.08,
    y: 0,
    width: 30.37,
    height: 30.97,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.898125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 181.26500000000001,
    y: 15.485,
    fontFamily: "Arial"
  }, "\n        Lunenburg_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 196.45,
    y: 0,
    width: 31.55,
    height: 30.97,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.821764705882353
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 212.225,
    y: 15.485,
    fontFamily: "Arial"
  }, "\n        Buckingham_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 228,
    y: 0,
    width: 31.6,
    height: 30.97,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.935625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 243.8,
    y: 15.485,
    fontFamily: "Arial"
  }, "\n        Charlotte_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 259.6,
    y: 0,
    width: 32.34,
    height: 30.97,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.63
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 275.77000000000004,
    y: 15.485,
    fontFamily: "Arial"
  }, "\n        King_William_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 291.93,
    y: 0,
    width: 32.87,
    height: 30.97,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.580833333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 308.365,
    y: 15.485,
    fontFamily: "Arial"
  }, "\n        Floyd_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 324.8,
    y: 0,
    width: 32.92,
    height: 30.97,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.7205555555555554
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 341.26,
    y: 15.485,
    fontFamily: "Arial"
  }, "\n        King_George_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 357.72,
    y: 0,
    width: 32.98,
    height: 30.97,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.4747619047619047
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 374.21000000000004,
    y: 15.485,
    fontFamily: "Arial"
  }, "\n        Northumberland_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 390.7,
    y: 0,
    width: 33.41,
    height: 30.97,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.821764705882353
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 407.405,
    y: 15.485,
    fontFamily: "Arial"
  }, "\n        Falls_Church_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 424.11,
    y: 0,
    width: 33.61,
    height: 30.97,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.382307692307692
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 440.915,
    y: 15.485,
    fontFamily: "Arial"
  }, "\n        Poquoson_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 457.72,
    y: 0,
    width: 33.9,
    height: 30.97,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.0646666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 474.67,
    y: 15.485,
    fontFamily: "Arial"
  }, "\n        New_Kent_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 491.62,
    y: 0,
    width: 34.18,
    height: 30.97,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.935625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 508.71,
    y: 15.485,
    fontFamily: "Arial"
  }, "\n        Lancaster_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 525.8,
    y: 0,
    width: 34.24,
    height: 30.97,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.382307692307692
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 542.92,
    y: 15.485,
    fontFamily: "Arial"
  }, "\n        Nelson_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 560.04,
    y: 0,
    width: 34.73,
    height: 30.97,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.7205555555555554
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 577.405,
    y: 15.485,
    fontFamily: "Arial"
  }, "\n        Northampton_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 594.77,
    y: 0,
    width: 34.75,
    height: 30.97,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.821764705882353
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 612.145,
    y: 15.485,
    fontFamily: "Arial"
  }, "\n        Appomattox_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 629.52,
    y: 0,
    width: 34.98,
    height: 30.97,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.935625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 647.01,
    y: 15.485,
    fontFamily: "Arial"
  }, "\n        Alleghany_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 664.49,
    y: 0,
    width: 35.51,
    height: 30.97,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.0646666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 682.245,
    y: 15.485,
    fontFamily: "Arial"
  }, "\n        Nottoway_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.27,
    y: 30.97,
    width: 36.49,
    height: 30.71,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.0473333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.515,
    y: 46.325,
    fontFamily: "Arial"
  }, "\n        Fluvanna_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.27,
    y: 61.69,
    width: 36.49,
    height: 32.66,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.7189473684210526
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.515,
    y: 78.02,
    fontFamily: "Arial"
  }, "\n        Westmoreland_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.27,
    y: 94.34,
    width: 36.49,
    height: 33.5,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.515,
    y: 111.09,
    fontFamily: "Arial"
  }, "\n        Prince_Edward_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.27,
    y: 127.84,
    width: 36.49,
    height: 34.73,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.0429411764705883
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.515,
    y: 145.205,
    fontFamily: "Arial"
  }, "\n        Martinsville_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.27,
    y: 162.57,
    width: 36.49,
    height: 35.26,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.20375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.515,
    y: 180.2,
    fontFamily: "Arial"
  }, "\n        Brunswick_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.27,
    y: 197.83,
    width: 36.49,
    height: 36.08,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.0044444444444443
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.515,
    y: 215.87,
    fontFamily: "Arial"
  }, "\n        Southampton_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.27,
    y: 233.9,
    width: 36.49,
    height: 36.1,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.9000000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.515,
    y: 251.95000000000002,
    fontFamily: "Arial"
  }, "\n        Fredericksburg_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.27,
    y: 270,
    width: 36.49,
    height: 36.42,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.6014285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.515,
    y: 288.21,
    fontFamily: "Arial"
  }, "\n        Grayson_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.27,
    y: 306.42,
    width: 36.49,
    height: 37.19,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.432666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.515,
    y: 325.015,
    fontFamily: "Arial"
  }, "\n        Powhatan_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.27,
    y: 343.61,
    width: 36.49,
    height: 37.52,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.432666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.515,
    y: 362.37,
    fontFamily: "Arial"
  }, "\n        Waynesboro_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.27,
    y: 381.12,
    width: 36.49,
    height: 37.73,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.6064285714285718
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.515,
    y: 399.985,
    fontFamily: "Arial"
  }, "\n        Patrick_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.27,
    y: 418.85,
    width: 36.49,
    height: 39.16,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.0408333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.515,
    y: 438.43,
    fontFamily: "Arial"
  }, "\n        Bristol_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.27,
    y: 458.01,
    width: 36.49,
    height: 39.25,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.280625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.515,
    y: 477.635,
    fontFamily: "Arial"
  }, "\n        Goochland_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.27,
    y: 497.26,
    width: 36.49,
    height: 39.38,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.146470588235294
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.515,
    y: 516.95,
    fontFamily: "Arial"
  }, "\n        Rockbridge_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.27,
    y: 536.64,
    width: 36.49,
    height: 40.05,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.0408333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.515,
    y: 556.665,
    fontFamily: "Arial"
  }, "\n        Giles_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.27,
    y: 576.69,
    width: 36.49,
    height: 40.42,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.432666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.515,
    y: 596.9000000000001,
    fontFamily: "Arial"
  }, "\n        Winchester_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.27,
    y: 617.11,
    width: 36.49,
    height: 40.69,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.432666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.515,
    y: 637.455,
    fontFamily: "Arial"
  }, "\n        Caroline_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.27,
    y: 657.8,
    width: 36.49,
    height: 42.2,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.806923076923077
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.515,
    y: 678.9,
    fontFamily: "Arial"
  }, "\n        Hopewell_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57.76,
    y: 30.97,
    width: 37.63,
    height: 41.44,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.351875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 76.575,
    y: 51.69,
    fontFamily: "Arial"
  }, "\n        Dickenson_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 95.4,
    y: 30.97,
    width: 38.39,
    height: 41.44,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.953076923076923
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 114.595,
    y: 51.69,
    fontFamily: "Arial"
  }, "\n        Louisa_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 133.79,
    y: 30.97,
    width: 38.82,
    height: 41.44,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.8485714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 153.2,
    y: 51.69,
    fontFamily: "Arial"
  }, "\n        Colonial_Heights_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 172.61,
    y: 30.97,
    width: 39.1,
    height: 41.44,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.5545454545454547
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 192.16000000000003,
    y: 51.69,
    fontFamily: "Arial"
  }, "\n        Page_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 211.71,
    y: 30.97,
    width: 39.73,
    height: 41.44,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.483125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 231.57500000000002,
    y: 51.69,
    fontFamily: "Arial"
  }, "\n        Dinwiddie_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 251.44,
    y: 30.97,
    width: 41.44,
    height: 41.44,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.1876923076923074
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 272.15999999999997,
    y: 51.69,
    fontFamily: "Arial"
  }, "\n        Orange_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 292.88,
    y: 30.97,
    width: 42.67,
    height: 41.44,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.1876923076923074
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 314.215,
    y: 51.69,
    fontFamily: "Arial"
  }, "\n        Staunton_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 335.55,
    y: 30.97,
    width: 43.5,
    height: 41.44,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.072
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 357.3,
    y: 51.69,
    fontFamily: "Arial"
  }, "\n        Prince_George_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 379.05,
    y: 30.97,
    width: 44.52,
    height: 41.44,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.4376470588235293
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 401.31,
    y: 51.69,
    fontFamily: "Arial"
  }, "\n        Harrisonburg_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 423.56,
    y: 30.97,
    width: 44.72,
    height: 41.44,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.1876923076923074
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 445.92,
    y: 51.69,
    fontFamily: "Arial"
  }, "\n        Warren_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 468.28,
    y: 30.97,
    width: 44.78,
    height: 41.44,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.453333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 490.66999999999996,
    y: 51.69,
    fontFamily: "Arial"
  }, "\n        Scott_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 513.07,
    y: 30.97,
    width: 44.8,
    height: 41.44,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.453333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 535.47,
    y: 51.69,
    fontFamily: "Arial"
  }, "\n        Fairfax_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 557.86,
    y: 30.97,
    width: 45.27,
    height: 41.44,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.144
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 580.495,
    y: 51.69,
    fontFamily: "Arial"
  }, "\n        Lee_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 603.14,
    y: 30.97,
    width: 48.37,
    height: 41.44,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.7626666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 627.3249999999999,
    y: 51.69,
    fontFamily: "Arial"
  }, "\n        Culpeper_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 651.51,
    y: 30.97,
    width: 48.49,
    height: 41.44,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.453333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 675.755,
    y: 51.69,
    fontFamily: "Arial"
  }, "\n        Wythe_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57.76,
    y: 72.41,
    width: 46.21,
    height: 44.22,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.422
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 80.865,
    y: 94.52,
    fontFamily: "Arial"
  }, "\n        Salem_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57.76,
    y: 116.63,
    width: 46.21,
    height: 45.21,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.2292857142857145
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 80.865,
    y: 139.23499999999999,
    fontFamily: "Arial"
  }, "\n        Amherst_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57.76,
    y: 161.83,
    width: 46.21,
    height: 45.23,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.2307142857142854
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 80.865,
    y: 184.44500000000002,
    fontFamily: "Arial"
  }, "\n        Carroll_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57.76,
    y: 207.07,
    width: 46.21,
    height: 45.46,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.5255555555555556
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 80.865,
    y: 229.79999999999998,
    fontFamily: "Arial"
  }, "\n        Mecklenburg_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57.76,
    y: 252.53,
    width: 46.21,
    height: 46.23,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.5546153846153845
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 80.865,
    y: 275.645,
    fontFamily: "Arial"
  }, "\n        Manassas_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57.76,
    y: 298.76,
    width: 46.21,
    height: 46.67,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.3007142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 80.865,
    y: 322.09499999999997,
    fontFamily: "Arial"
  }, "\n        Halifax_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57.76,
    y: 345.43,
    width: 46.21,
    height: 47.19,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.3105
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 80.865,
    y: 369.025,
    fontFamily: "Arial"
  }, "\n        Isle_of_Wight_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 88,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57.76,
    y: 392.62,
    width: 46.21,
    height: 47.59,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.3007142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 80.865,
    y: 416.415,
    fontFamily: "Arial"
  }, "\n        Russell_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 89,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57.76,
    y: 440.21,
    width: 46.21,
    height: 48.5,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.0806666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 80.865,
    y: 464.46,
    fontFamily: "Arial"
  }, "\n        Buchanan_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 90,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57.76,
    y: 488.72,
    width: 46.21,
    height: 50.6,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.888125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 80.865,
    y: 514.02,
    fontFamily: "Arial"
  }, "\n        Botetourt_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 91,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57.76,
    y: 539.31,
    width: 46.21,
    height: 52.7,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.0806666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 80.865,
    y: 565.66,
    fontFamily: "Arial"
  }, "\n        Petersburg_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 92,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57.76,
    y: 592.02,
    width: 46.21,
    height: 53.59,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.8508333333333336
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 80.865,
    y: 618.8149999999999,
    fontFamily: "Arial"
  }, "\n        Smyth_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 93,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57.76,
    y: 645.61,
    width: 46.21,
    height: 54.39,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.0806666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 80.865,
    y: 672.8050000000001,
    fontFamily: "Arial"
  }, "\n        Accomack_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 94,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 103.97,
    y: 72.41,
    width: 44.66,
    height: 57.22,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.6270588235294117
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 126.3,
    y: 101.02,
    fontFamily: "Arial"
  }, "\n        Gloucester_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 95,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 148.64,
    y: 72.41,
    width: 46.51,
    height: 57.22,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.7358823529411764
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 171.89499999999998,
    y: 101.02,
    fontFamily: "Arial"
  }, "\n        Shenandoah_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 96,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 195.14,
    y: 72.41,
    width: 46.81,
    height: 57.22,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.343571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 218.545,
    y: 101.02,
    fontFamily: "Arial"
  }, "\n        Pulaski_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 97,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 241.96,
    y: 72.41,
    width: 49.72,
    height: 57.22,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.52
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 266.82,
    y: 101.02,
    fontFamily: "Arial"
  }, "\n        Wise_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 98,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 291.68,
    y: 72.41,
    width: 49.86,
    height: 57.22,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.493
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 316.61,
    y: 101.02,
    fontFamily: "Arial"
  }, "\n        Charlottesville_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 99,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 341.55,
    y: 72.41,
    width: 52.55,
    height: 57.22,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.503333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 367.825,
    y: 101.02,
    fontFamily: "Arial"
  }, "\n        Franklin_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 100,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 394.09,
    y: 72.41,
    width: 57.08,
    height: 57.22,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.805333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 422.63,
    y: 101.02,
    fontFamily: "Arial"
  }, "\n        Tazewell_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 101,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 451.18,
    y: 72.41,
    width: 58.46,
    height: 57.22,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.57625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 480.41,
    y: 101.02,
    fontFamily: "Arial"
  }, "\n        Frederick_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 102,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 509.64,
    y: 72.41,
    width: 60.98,
    height: 57.22,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.3658823529411763
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 540.13,
    y: 101.02,
    fontFamily: "Arial"
  }, "\n        James_City_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 103,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 570.62,
    y: 72.41,
    width: 63.57,
    height: 57.22,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.3658823529411763
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 602.405,
    y: 101.02,
    fontFamily: "Arial"
  }, "\n        Washington_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 104,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 634.2,
    y: 72.41,
    width: 65.8,
    height: 57.22,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.401538461538461
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 667.1,
    y: 101.02,
    fontFamily: "Arial"
  }, "\n        Danville_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 105,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 103.97,
    y: 129.63,
    width: 63.3,
    height: 59.77,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.984666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 135.62,
    y: 159.515,
    fontFamily: "Arial"
  }, "\n        Campbell_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 106,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 103.97,
    y: 189.4,
    width: 63.3,
    height: 60.4,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.490909090909091
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 135.62,
    y: 219.6,
    fontFamily: "Arial"
  }, "\n        York_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 107,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 103.97,
    y: 249.8,
    width: 63.3,
    height: 61.18,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.098333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 135.62,
    y: 280.39,
    fontFamily: "Arial"
  }, "\n        Suffolk_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 108,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 103.97,
    y: 310.98,
    width: 63.3,
    height: 62.79,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.485
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 135.62,
    y: 342.375,
    fontFamily: "Arial"
  }, "\n        Bedford_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 109,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 103.97,
    y: 373.77,
    width: 63.3,
    height: 62.8,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.1866666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 135.62,
    y: 405.16999999999996,
    fontFamily: "Arial"
  }, "\n        Fauquier_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 110,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 103.97,
    y: 436.57,
    width: 63.3,
    height: 65.02,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.7235294117647055
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 135.62,
    y: 469.08,
    fontFamily: "Arial"
  }, "\n        Rockingham_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 111,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 103.97,
    y: 501.59,
    width: 63.3,
    height: 66.03,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.2749999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 135.62,
    y: 534.605,
    fontFamily: "Arial"
  }, "\n        Henry_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 112,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 103.97,
    y: 567.62,
    width: 63.3,
    height: 66.15,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.521428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 135.62,
    y: 600.695,
    fontFamily: "Arial"
  }, "\n        Augusta_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 113,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 103.97,
    y: 633.77,
    width: 63.3,
    height: 66.23,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.331578947368421
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 135.62,
    y: 666.885,
    fontFamily: "Arial"
  }, "\n        Pittsylvania_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 114,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 167.28,
    y: 129.63,
    width: 63.95,
    height: 71.91,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.365789473684211
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 199.255,
    y: 165.58499999999998,
    fontFamily: "Arial"
  }, "\n        Spotsylvania_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 115,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 231.23,
    y: 129.63,
    width: 66.24,
    height: 71.91,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.4159999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 264.34999999999997,
    y: 165.58499999999998,
    fontFamily: "Arial"
  }, "\n        Stafford_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 116,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 297.46,
    y: 129.63,
    width: 66.41,
    height: 71.91,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.906470588235294
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 330.66499999999996,
    y: 165.58499999999998,
    fontFamily: "Arial"
  }, "\n        Montgomery_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 117,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 363.87,
    y: 129.63,
    width: 66.5,
    height: 71.91,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.75
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 397.12,
    y: 165.58499999999998,
    fontFamily: "Arial"
  }, "\n        Lynchburg_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 118,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 430.37,
    y: 129.63,
    width: 84.7,
    height: 71.91,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.494375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 472.72,
    y: 165.58499999999998,
    fontFamily: "Arial"
  }, "\n        Albemarle_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 119,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 515.07,
    y: 129.63,
    width: 91.24,
    height: 71.91,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.136428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 560.69,
    y: 165.58499999999998,
    fontFamily: "Arial"
  }, "\n        Hanover_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 120,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 606.31,
    y: 129.63,
    width: 93.69,
    height: 71.91,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.9925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 653.155,
    y: 165.58499999999998,
    fontFamily: "Arial"
  }, "\n        Roanoke_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 121,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 167.28,
    y: 201.54,
    width: 85.6,
    height: 84.12,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.6080000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 210.07999999999998,
    y: 243.6,
    fontFamily: "Arial"
  }, "\n        Portsmouth_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 122,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 167.28,
    y: 285.66,
    width: 85.6,
    height: 91.9,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.114285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 210.07999999999998,
    y: 331.61,
    fontFamily: "Arial"
  }, "\n        Roanoke_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 123,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 167.28,
    y: 377.56,
    width: 85.6,
    height: 93.01,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.114285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 210.07999999999998,
    y: 424.065,
    fontFamily: "Arial"
  }, "\n        Loudoun_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 124,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 167.28,
    y: 470.57,
    width: 85.6,
    height: 111.59,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.133333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 210.07999999999998,
    y: 526.365,
    fontFamily: "Arial"
  }, "\n        Hampton_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 125,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 167.28,
    y: 582.16,
    width: 85.6,
    height: 117.84,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.706666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 210.07999999999998,
    y: 641.0799999999999,
    fontFamily: "Arial"
  }, "\n        Alexandria_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 126,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 252.88,
    y: 201.54,
    width: 102.05,
    height: 114.64,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.002941176470588
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 303.905,
    y: 258.86,
    fontFamily: "Arial"
  }, "\n        Newport_News_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 127,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 354.93,
    y: 201.54,
    width: 103.35,
    height: 114.64,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.89
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 406.605,
    y: 258.86,
    fontFamily: "Arial"
  }, "\n        Chesapeake_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 128,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 458.27,
    y: 201.54,
    width: 115.31,
    height: 114.64,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.553333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 515.925,
    y: 258.86,
    fontFamily: "Arial"
  }, "\n        Norfolk_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 129,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 573.58,
    y: 201.54,
    width: 126.42,
    height: 114.64,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.459047619047619
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 636.7900000000001,
    y: 258.86,
    fontFamily: "Arial"
  }, "\n        Prince_William_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 130,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 252.88,
    y: 316.18,
    width: 131.85,
    height: 115.81,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.90846153846154
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 318.805,
    y: 374.08500000000004,
    fontFamily: "Arial"
  }, "\n        Richmond_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 131,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 252.88,
    y: 432,
    width: 131.85,
    height: 119.95,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.496875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 318.805,
    y: 491.975,
    fontFamily: "Arial"
  }, "\n        Arlington_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 132,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 252.88,
    y: 551.95,
    width: 131.85,
    height: 148.05,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.939473684210526
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 318.805,
    y: 625.975,
    fontFamily: "Arial"
  }, "\n        Chesterfield_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 133,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 384.73,
    y: 316.18,
    width: 139.16,
    height: 149.82,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.94
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 454.31,
    y: 391.09000000000003,
    fontFamily: "Arial"
  }, "\n        Henrico_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 134,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 523.88,
    y: 316.18,
    width: 176.12,
    height: 149.82,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.8852631578947365
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 611.94,
    y: 391.09000000000003,
    fontFamily: "Arial"
  }, "\n        Virginia_Beach_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 135,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 384.73,
    y: 466.01,
    width: 315.27,
    height: 233.99,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.71357142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 542.365,
    y: 583.005,
    fontFamily: "Arial"
  }, "\n        Fairfax_County\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1992);
export default __webpack_public_path__ + "static/media/1992.3172828366e1199e739bdb00cc8ea065.svg";
export { ForwardRef as ReactComponent };